// Runtime value that can be used to represent the above type for dependency injection
export const InterceptorCollection = Symbol("InterceptorCollection");
const DEFAULT_PRIORITY = Infinity;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const interceptorPriorityComparator = (a, b) => {
    var _a, _b;
    if (((_a = a.priority) !== null && _a !== void 0 ? _a : DEFAULT_PRIORITY) < ((_b = b.priority) !== null && _b !== void 0 ? _b : DEFAULT_PRIORITY)) {
        return -1;
    }
    else if (a.priority === b.priority) {
        return 0;
    }
    else {
        return 1;
    }
};
//# sourceMappingURL=Interceptor.js.map